import { Col, Grid, Row } from 'rsuite'
import { useRouter } from 'next/router'
import useTranslation from '@/hooks/useTranslation'
import { ActionButton, ContentContainer } from '@/components/styles'
import styles from './unavailable.module.scss'

const ServiceWarrantyUnavailable = () => {
  const t = useTranslation()
  const router = useRouter()

  const goBack = () => {
    if (window.history.length > 1) {
      router.back()
      return
    }

    router.push('/')
  }

  return (
    <ContentContainer className={styles.container}>
      <Grid fluid>
        <Row gutter={50}>
          <Col xs={24} xl={16} className="mt-20">
            <h1 className={styles.title}>{t('service_warranty', 'Service & Warranty')}</h1>
            <p className={styles.message}>
              {t(
                'service_warranty_not_available',
                'Please contact your Authorised Retailer to obtain  Service&Warranty'
              )}
            </p>
            <ActionButton appearance="primary" className={styles.action} onClick={goBack}>
              {t('back', 'Back')}
            </ActionButton>
          </Col>
        </Row>
      </Grid>
    </ContentContainer>
  )
}

export default ServiceWarrantyUnavailable
